import LegalPage from "@/components/site/LegalPage";
import { BRAND } from "@/data/content";

const SECTIONS = [
  {
    heading: "Who we are",
    paras: [
      `This Privacy Policy explains how ${BRAND.fullName} ("BLEZZINGS", "we", "us") collects, uses, stores and protects personal information when you visit blezzings.co or interact with us through it. We are a Sales & Marketing transformation consultancy based in ${BRAND.contact.location}, India.`,
      `If you have any questions about this policy or your data, you can reach us at ${BRAND.contact.email} or ${BRAND.contact.phone}.`,
    ],
  },
  {
    heading: "Information we collect",
    paras: ["We collect only the information needed to respond to you and operate this website:"],
    bullets: [
      "Enquiry and consultation forms: your name, email address, phone number, company, preferred consultation date and time, and the message you send us.",
      "Careers applications: your name, email address, phone number, area of expertise, LinkedIn or profile links, your note, and your CV if you choose to upload one.",
      "Newsletter sign-up: your email address.",
      "Usage data: pages visited, approximate location, device and browser information, collected through cookies and analytics tools when enabled.",
    ],
  },
  {
    heading: "How we use your information",
    bullets: [
      "To respond to your enquiry and schedule a consultation you have requested.",
      "To evaluate your careers application and contact you about relevant opportunities.",
      "To send you updates you have explicitly subscribed to.",
      "To understand how the website is used and to improve its content and performance.",
      "To meet legal, regulatory or security obligations where required.",
    ],
    paras: ["We do not sell, rent or trade your personal information to anyone."],
  },
  {
    heading: "Cookies and analytics",
    paras: [
      "This website uses Google Analytics to understand aggregate visitor behaviour — for example, which pages are read and how visitors arrive. Analytics cookies are only used where you have allowed them.",
      "You can accept or decline analytics cookies at any time through the Cookie Preferences link in the website footer. Declining stops analytics measurement on this device going forward; essential cookies required for the site to function remain active.",
    ],
  },
  {
    heading: "Who we share it with",
    paras: [
      "We share personal information only with the service providers that help us operate — for example email delivery, website hosting and analytics providers — and only to the extent needed for those services. We may also disclose information where required by law or to protect our legal rights.",
    ],
  },
  {
    heading: "How long we keep it",
    paras: [
      "We keep personal information only for as long as it is needed for the purpose it was collected — for example, for the duration of an enquiry conversation or a recruitment process — after which it is deleted or anonymised, unless a longer retention period is required by law.",
    ],
  },
  {
    heading: "How we protect it",
    paras: [
      "We apply reasonable technical and organisational safeguards to protect personal information against unauthorised access, loss or misuse. No method of transmission over the internet is completely secure, so we cannot guarantee absolute security, but we treat the protection of your information as a priority.",
    ],
  },
  {
    heading: "Your rights",
    paras: [
      `You may request access to the personal information we hold about you, ask for it to be corrected or deleted, or withdraw consent you have given, at any time. To do so, write to us at ${BRAND.contact.email}. We will respond within a reasonable timeframe.`,
    ],
  },
  {
    heading: "Third-party links",
    paras: [
      "Our website may link to third-party websites such as LinkedIn. We are not responsible for the privacy practices of those sites, and we encourage you to read their privacy policies.",
    ],
  },
  {
    heading: "Changes to this policy",
    paras: [
      "We may update this Privacy Policy from time to time. The latest version will always be published on this page with its revision date.",
    ],
  },
  {
    heading: "Contact us",
    paras: [
      `${BRAND.fullName}, ${BRAND.contact.location}, India.`,
      `Email: ${BRAND.contact.email} · Phone: ${BRAND.contact.phone}`,
    ],
  },
];

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      testid="privacy-policy-page"
      badge="Legal"
      title="Privacy Policy"
      intro="How BLEZZINGS collects, uses and protects your personal information — and the choices you have."
      updated="July 2026"
      sections={SECTIONS}
      meta={{
        title: "Privacy Policy | BLEZZINGS Growth Partners",
        description:
          "How BLEZZINGS Growth Partners collects, uses, stores and protects personal information across its website, enquiry forms and careers applications.",
        canonical: "https://blezzings.co/privacy-policy",
        breadcrumbs: [
          { name: "Home", url: "https://blezzings.co/" },
          { name: "Privacy Policy", url: "https://blezzings.co/privacy-policy" },
        ],
      }}
    />
  );
}
